import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { useSelector, useDispatch } from "react-redux";
import { FaRegEdit } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { TestData } from "../../Redux/Reducers/NCLadmin/AddEditTest";
import { FaAnglesLeft } from "react-icons/fa6";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import axiosInstance from "../../ReusableComponents/Axios";
import { FaClockRotateLeft } from "react-icons/fa6";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { format } from "date-fns";
const WeeklyTests = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [Test, SetTest] = useState([]);
  const [LogDetails, SetLogDetails] = useState([]);
  const [LogModal, setLogModal] = useState(null);
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  // Fetches assessment schedules for a selected assessment type (Sodhana/Sadhana/Samagra)
  const Assessments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetInstituteWiseAssessmentDetails?AssessmentId=${location.state?.AssessmentId}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetTest(response.data);
    } catch (error) {
      console.error("Error fetching Assessment data:", error);
      return [];
    }
  };
  useEffect(() => {
    Assessments();
  }, [location.state?.AssessmentId]);

  //API for Activity Log Details 
  const ActivityLogDetails = async (row) => {
    setLogModal({
      instituteCode: row.instituteCode,
      grades: row.grades
    });
    SetLogDetails("");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetAssessmentActivityLog?AssessmentScheduleId=${row.assessmentScheduleId}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLogDetails(response.data);
    } catch (error) {
      console.error("Error fetching Assessment data:", error);
      return [];
    }
  };

  // Navigates to AddTest screen to add a NEW weekly schedule
  const AddWeeklyAssessments = () => {
    navigate("/NCLAdmin/Assessments/AddTest", { state: { AssessmentName: location.state?.AssessmentName, AssessmentId: location.state?.AssessmentId,AssessmentType : location.state?.SelecTYpe } });
    dispatch(TestData({ TestDetails: "" }));
  };
  // Navigates to AddTest screen for EDITING an existing assessment schedule
  const handleEdit = async (SingleAssessment) => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetAssessmentQuestionDetailsForUpdate?AssessmentScheduleId=${SingleAssessment?.assessmentScheduleId}`);
      dispatch(TestData({ TestDetails: res.data }));
      navigate("/NCLAdmin/Assessments/AddTest", { state: { AssessmentName: location.state?.AssessmentName, AssessmentId: location.state?.AssessmentId } });
    }
    catch (err) {
      console.log(err)
    }
  };
  // Opens Question Paper View Screen for selected Schedule
  const ViewAssessmentQuestionpaper = (row) => {
    navigate("/NCLAdmin/Assessments/AssessmentQuestionPaper", {
      state: {
        AssessmentScheduleId: row.assessmentScheduleId, Grade: row.grades, AType: location.state?.AssessmentName
        , InstituteCode: row.instituteCode, date: row.examStartDate
      }
    });
  }
  // Navigates back to previous screen
  const CancelAssessments = () => {
    navigate(-1);
  };

  //Used to define columns for list of Assessments 
  const Columns = [
    { name: "Institute", selector: "instituteCode", sortable: false },
    {
      name: "Society", selector: "society", sortable: true,
      cell: (row) => row.society === "" ? "-" : row.society
    },
    { name: "Schedule", selector: "examStartDate", sortable: true },
    { name: "Subjects", selector: "subjectName", sortable: true },
    { name: "Grades", selector: "grades", sortable: true },
    { name: "Duration", selector: "duration", sortable: true },
    { name: "Credits", selector: "credits", sortable: true },
    { name: "Status", selector: "status", sortable: true },
    {
      name: "Question Paper",
      cell: (row) => (
        <>
          <a
            onClick={() => ViewAssessmentQuestionpaper(row)}
            style={{ color: "#007bff", textDecoration: "none", marginLeft: "8px", cursor: "pointer" }}
          >
            View
          </a>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Action",
      selector: "action",
      sortable: false,
      cell: (row) => (
        <div
          className="dflex CPointer alignitems"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEdit
            style={{ color: "#624DE3" }}
            className="CPointer"
            title="Edit Assessment"
            onClick={() => handleEdit(row)}
          />
          <FaClockRotateLeft
            className="LinkStyles"
            style={{ textWrap: "nowrap", gap: "15px", }}
            onClick={() => ActivityLogDetails(row)}
            title="View Assessment Activity Log" />
        </div>
      ),
    },
  ];
  //Used to define columns for Activity Log popup
  const logColumns = [
    { name: "Field", selector: "field" },
    {
      name: "Assessment Start Date", selector: "oldValue",
      cell: (row) => format(new Date(row.oldValue), "dd-MM-yyyy HH:mm a")
    },
    {
      name: "Assessment End Date", selector: "newValue",
      cell: (row) => format(new Date(row.newValue), "dd-MM-yyyy HH:mm a")
    },
    { name: "Modified By", selector: "modifiedBy" },
    { name: "Modified Date", selector: "modifiedDate" },
  ];

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />

        <div className="dflex alignitems JSBetween">
          <div
            className=" Buttons BackNavigation mb-3 "
            style={{ float: "left" }}
            onClick={CancelAssessments}
          >
            <FaAnglesLeft /> Back{" "}
          </div>
          <div className="MainHeading">
            {location.state?.AssessmentName} - Assessment Schedules ({USYear?.display})
          </div>
          <div className="dflex alignitems gap-3">
            <button className="Buttons AddButton" onClick={AddWeeklyAssessments}>
              <HiMiniPlusSmall />
              Add Schedule{" "}
            </button>
          </div>
        </div>

        <DataTable
          data={Test}
          columns={Columns}
          className="NCLDataTable Card mt-2"
          style={{ marginTop: "40px" }}
          Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true}
          ShowPagecount={true}
        />
      </div>

      {LogModal && (
        <div className="Model-Open">
          <div className="Card  m-4 w-50">
            <div className="dflex JSBetween">
              <div className="SubHeading">
                {location.state?.AssessmentName} - {LogModal?.instituteCode} (
                {LogModal?.grades?.includes(",") ? "Grades" : "Grade"} {LogModal?.grades}
                ) - Assessment Log
              </div>
              <IoMdCloseCircleOutline
                className="NCERTClose CPointer"
                onClick={() => setLogModal(false)}
              />
            </div>
            <DataTable
              className="NCLDataTable"
              data={LogDetails}
              columns={logColumns}
            />
          </div>{" "}
        </div>
      )}
    </>
  );
};
export default WeeklyTests;